import { jsx as _jsx } from "react/jsx-runtime";
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { SEARCH_RESULTS_MAX } from '../../constants/search';

const ResultsMaxWarning = () => {
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: "marketplace-ui-common.resultsMaxWarning",
    options: {
      max: I18n.abbreviateNumber(SEARCH_RESULTS_MAX)
    }
  });
};

export default ResultsMaxWarning;